"use client"
import React, { forwardRef, useContext } from "react"
import { tv, type VariantProps } from "tailwind-variants"
import { classNames } from "../../utils"
import { FlexCenter, FlexCenterProps } from "../FlexCenter"
import { TableRowContext } from "./TableRowContext"

const tableCellVariants = tv({
  variants: {
    align: {
      left: "justify-start",
      center: "justify-center",
      right: "justify-end",
    },
  },
})

export type TableCellProps = {
  role?: "cell" | "columnheader"
  /**
   * Set to a number to make the cell horizontally sticky. ex. for horizontal scrolling
   */
  stickyLeft?: number
} & VariantProps<typeof tableCellVariants> &
  FlexCenterProps

export const TableCell = forwardRef<HTMLDivElement, TableCellProps>(
  function TableCell(
    { children, className, stickyLeft, role = "cell", align = "left", ...rest },
    ref,
  ) {
    const { interactive } = useContext(TableRowContext)

    return (
      <FlexCenter
        className={classNames(
          "w-[128px] shrink-0 grow-0 overflow-hidden first:pl-2 last:pr-2",
          stickyLeft !== undefined && "sticky z-[1] h-full bg-bg-app",
          stickyLeft !== undefined &&
            interactive &&
            "!bg-bg-app group-hover:!bg-bg-additional-1 group-active:!bg-bg-additional-2",
          tableCellVariants({ align }),
          className,
        )}
        ref={ref}
        role={role}
        style={{
          left: stickyLeft,
        }}
        {...rest}
      >
        {children}
      </FlexCenter>
    )
  },
)
